// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/user.js';

import { paths } from '../generated/user';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('user', Original, paths);
